"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
//******************************************************************************
// Copyright 2018-2020, ShareSquared Inc., All Rights Reserved.
//
// Author:  Ted Iverson
// Created: 06/25/2020
//
// The contents of this file are proprietary and considered trade secret.
// Any disclosure outside of its intended use is expressly prohibited.
//******************************************************************************
var React = require("react");
var DetailsList_1 = require("@fluentui/react/lib/DetailsList");
var Spinner_1 = require("@fluentui/react/lib/Spinner");
var Label_1 = require("@fluentui/react/lib/Label");
var date_fns_1 = require("date-fns");
var Icon_1 = require("@fluentui/react/lib/Icon");
var file_type_icons_1 = require("@uifabric/file-type-icons");
var Button_1 = require("@fluentui/react/lib/Button");
var react_1 = require("@fluentui/react");
var Pager = require('rc-pager');
require('rc-pager/assets/bootstrap.css');
var SearchResults = /** @class */ (function (_super) {
    __extends(SearchResults, _super);
    function SearchResults(props, state) {
        var _this = _super.call(this, props, state) || this;
        _this.state = {
            Items: [],
            Processing: false,
            ShowResults: false,
            MaxPages: 0,
            CurrentPage: 0,
            TotalCount: 0,
            ViewAll: false,
            DownloadProcessing: false,
            Action: "0",
            ZipEmail: ""
        };
        // if a reference callback has been provided, call it
        if (_this.props.Ref !== undefined)
            _this.props.Ref(_this);
        _this._Selection = new DetailsList_1.Selection({
            onSelectionChanged: function () { return _this.setState({}); },
        });
        return _this;
    }
    SearchResults.prototype.clearResults = function () {
        this.setState({
            Items: [],
            Processing: false,
            ShowResults: false,
            MaxPages: 0,
            CurrentPage: 0,
            TotalCount: 0,
            ViewAll: false,
            DownloadProcessing: false,
            Action: "0",
            ZipEmail: ""
        });
    };
    SearchResults.prototype.search = function (query) {
        var _this = this;
        var sort = this.state.Sort;
        if (sort === undefined) {
            sort = this.props.Template.results.sort;
            this.setState({ Sort: sort });
        }
        // build the select properties array
        var selectProperties = [];
        this.props.Template.results.fields.forEach(function (f, idx) {
            selectProperties.push(f.property);
        });
        // build the sort properties array
        // NOTE: we currently only support one sort property, but this code 
        // and SharePoint API supports multiples
        var sortProperties = [];
        sortProperties.push(sort);
        // add the sort property to the result properties list, if specified
        if (selectProperties.indexOf(sort.property) === -1) {
            selectProperties.push(sort.property);
        }
        this.setState({ ShowResults: true, Processing: true });
        this._Selection.setAllSelected(false);
        var searchRequest = {
            Query: query,
            SelectProperties: selectProperties,
            ResultSource: this.props.Template.resultSource,
            ResultSourceScope: this.props.Template.resultSourceScope,
            SortProperties: sortProperties.length !== 0 ? sortProperties : undefined,
            StartRow: this.state.ViewAll ? 0 : this.state.CurrentPage * this.props.GlobalSettings.pageSize,
            RowLimit: this.state.ViewAll ? 500 : this.props.GlobalSettings.pageSize
        };
        var body = JSON.stringify(searchRequest);
        //console.log(`body=`, body);
        fetch((window.location.pathname === "/" ? "" : window.location.pathname) + "/api/query", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: body
        })
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({
                Items: data.DataLines,
                Processing: false,
                MaxPages: Math.ceil(data.TotalCount / _this.props.GlobalSettings.pageSize),
                TotalCount: data.TotalCount
            });
        })
            .catch(function (e) {
            _this.handleError("An error occured processing the search request.  If the error persists, please contact the administrator.");
        });
    };
    SearchResults.prototype.renderFormat = function (fieldDef, item) {
        var _this = this;
        var f = undefined;
        if (fieldDef.format.length !== 0) {
            switch (fieldDef.fieldType.toLowerCase()) {
                case "date": {
                    try {
                        var d = new Date(Date.parse(item[fieldDef.property]));
                        f = (React.createElement("span", null, date_fns_1.format(d, fieldDef.format)));
                    }
                    catch (e) { }
                    break;
                }
                case "number": {
                    try {
                        var ft = parseFloat(item[fieldDef.property]);
                        f = (React.createElement("span", null, this.formatNumber(fieldDef.format, ft)));
                    }
                    catch (e) { }
                    break;
                }
            }
        }
        if (fieldDef.property.toLowerCase() === "title") {
            // create a link to the API controller that will proxy
            // the requested document
            // NOTE: Path is assumed to be added to the return results in API controller
            var href_1 = item["Path"];
            if (this.props.GlobalSettings.linkBehavior === "PromptDownload") {
                f = (React.createElement("a", { href: "api/file?url=" + href_1, target: "_blank" }, item[fieldDef.property]));
            }
            else {
                f = (React.createElement("a", { href: "#", onClick: function (evt) {
                        fetch((window.location.pathname === "/" ? "" : window.location.pathname) + "/api/link?url=" + href_1)
                            .then(function (response) { return response.text(); })
                            .then(function (url) {
                            if (url.length !== 0)
                                window.open(url, "_blank");
                            else
                                _this.handleLinkError("An error occured processing the link.  If the error persists, please contact the administrator.");
                        })
                            .catch(function (e) {
                            _this.handleLinkError("An error occured processing the link.  If the error persists, please contact the administrator.");
                        });
                        evt.preventDefault();
                    } }, item[fieldDef.property]));
            }
        }
        else if (fieldDef.property.toLowerCase() === "filetype") {
            var ext = item["FileType"].toLowerCase();
            if (ext.length !== 0)
                f = React.createElement(Icon_1.Icon, __assign({}, file_type_icons_1.getFileTypeIconProps({ extension: ext, size: 16, imageFileType: 'svg' })));
        }
        //else if (fieldDef.property.toLowerCase() === "hithighlightedsummary") {
        //var summary = item[fieldDef.property] as string;
        //f = (<span>{summary.replace(/<c0>/g, "<span style='background-color:yellow;'>").replace(/<\/c0>/g, "</span>")}</span>);
        //}
        return f;
    };
    SearchResults.prototype.handleError = function (errorMessage) {
        if (this.props.OnError) {
            this.props.OnError(errorMessage);
            this.setState({ ShowResults: false });
        }
    };
    SearchResults.prototype.handleLinkError = function (errorMessage) {
        if (this.props.OnLinkError) {
            this.props.OnLinkError(errorMessage);
        }
    };
    SearchResults.prototype.isCustomRendererNeeded = function (fieldDef) {
        return (fieldDef.format && fieldDef.format.length !== 0 &&
            (fieldDef.fieldType.toLowerCase() === "date" || fieldDef.fieldType.toLowerCase() === "number")) ||
            fieldDef.property.toLowerCase() === "title" ||
            //fieldDef.property.toLowerCase() === "hithighlightedsummary" ||
            fieldDef.property.toLowerCase() === "filetype";
    };
    SearchResults.prototype.handleSkip = function (page) {
        var _this = this;
        this.setState({ CurrentPage: page }, function () {
            _this.search(_this.props.Query);
        });
    };
    SearchResults.prototype.render = function () {
        var _this = this;
        var columns = [];
        // build the select properties array
        if (this.props.Template) {
            this.props.Template.results.fields.forEach(function (f, idx) {
                var key = "colkey_" + idx;
                columns.push({
                    key: key,
                    name: f.label,
                    fieldName: f.property,
                    minWidth: f.width,
                    maxWidth: f.width,
                    isResizable: false,
                    isSorted: _this.state.Sort && _this.state.Sort.property.toLowerCase() === f.property.toLowerCase(),
                    isSortedDescending: _this.state.Sort && _this.state.Sort.direction === 1,
                    onColumnClick: function (evt, col) {
                        // NOTE: we limit user-sorting to column already configured for sorting
                        // (we can't guarantee all columns are sortable in Search)
                        if (_this.state.Sort && _this.state.Sort.property.toLowerCase() === f.property.toLowerCase()) {
                            _this.setState({ Sort: { property: f.property, direction: _this.state.Sort.direction === 1 ? 0 : 1 }, CurrentPage: 0 }, function () {
                                _this.search(_this.props.Query);
                            });
                        }
                    },
                    // We only register a render handler for date and number columns where a format is specified
                    // or the Title column so we can make it a link
                    onRender: _this.isCustomRendererNeeded(f) ? function (item) { return _this.renderFormat(f, item); } : undefined
                });
            });
        }
        var rx = new RegExp("^(.+)#(.+)#");
        var rxa = rx.exec(this.props.GlobalSettings.manualRequestLink);
        var actionOptions = [
            { key: "0", text: "Download Zip", selected: true },
        ];
        if (this.props.GlobalSettings.zipEmailEnabled) {
            actionOptions.push({ key: "1", text: "Email Zip", selected: false });
        }
        return (React.createElement("div", { className: "S2SearchResults", hidden: !this.state.ShowResults },
            React.createElement("div", { className: "S2SearchResultsLabelRow" },
                React.createElement("span", { className: "S2SearchResultsLabelx" },
                    React.createElement(Label_1.Label, { className: "S2SearchResultsLabel" },
                        "Results",
                        React.createElement("span", { className: 'S2SearchResultsCount', hidden: this.state.Items.length === 0 },
                            "(",
                            this.formatNumber("###,###.", this.state.TotalCount),
                            ")"),
                        React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small, hidden: !this.state.Processing }))),
                React.createElement("span", { hidden: this._Selection.getSelectedCount() === 0 },
                    React.createElement(react_1.Dropdown, { className: "S2ActionDropDown", options: actionOptions, styles: { dropdown: { width: "inherit" } }, selectedKey: this.state.Action, onChange: function (evt, val) {
                            _this.setState({ Action: val === null || val === void 0 ? void 0 : val.key });
                        } }),
                    React.createElement("span", { hidden: this.state.Action === "0" },
                        React.createElement(react_1.TextField, { className: "S2Input S2TextField S2ActionZipEmail", placeholder: "Email", value: this.state.ZipEmail, onChange: function (evt, v) {
                                if (v !== undefined) {
                                    _this.setState({ ZipEmail: v });
                                }
                            } })),
                    React.createElement(Button_1.DefaultButton, { className: "S2ActionButton", text: this.state.Action === "0" ? "Download" : "Send", disabled: this.state.Action === "1" && this.state.ZipEmail.length === 0, onClick: function () {
                            _this.setState({ DownloadProcessing: true });
                            var items = _this._Selection.getSelection();
                            var selectedItems = items.map(function (i) {
                                return i.Path;
                            });
                            if (_this.state.Action === "0") {
                                fetch((window.location.pathname === "/" ? "" : window.location.pathname) + "/api/zipdownload", {
                                    method: "POST",
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify(selectedItems)
                                }).then(function (response) {
                                    if (response.status !== 200) {
                                        var errorMessage = "Error processing the request... (" + response.status + " " + response.statusText + ")";
                                        throw new Error(errorMessage);
                                    }
                                    else {
                                        return response.blob();
                                    }
                                }).then(function (blob) {
                                    var element = document.createElement('a');
                                    element.setAttribute('href', URL.createObjectURL(blob));
                                    element.setAttribute('download', "RecordsSearch.zip");
                                    element.style.display = 'none';
                                    document.body.appendChild(element);
                                    element.click();
                                    document.body.removeChild(element);
                                    _this.setState({ DownloadProcessing: false });
                                }).catch(function (e) {
                                    _this.setState({ DownloadProcessing: false });
                                    console.log("e:", e);
                                    _this.handleError("An error occured processing the download request.  If the error persists, please contact the administrator.");
                                });
                            }
                            else {
                                var zr = {
                                    zipEmail: _this.state.ZipEmail,
                                    filePaths: selectedItems
                                };
                                fetch((window.location.pathname === "/" ? "" : window.location.pathname) + "/api/zipemail", {
                                    method: "POST",
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify(zr)
                                }).then(function (response) {
                                    if (response.status !== 200) {
                                        var errorMessage = "Error processing the request... (" + response.status + " " + response.statusText + ")";
                                        throw new Error(errorMessage);
                                    }
                                    else {
                                        _this.setState({ DownloadProcessing: false });
                                        alert(_this.props.GlobalSettings.zipEmailSuccess);
                                    }
                                }).catch(function (e) {
                                    _this.setState({ DownloadProcessing: false });
                                    console.log("e:", e);
                                    _this.handleError("An error occured processing the email request.  If the error persists, please contact the administrator.");
                                });
                            }
                        } })),
                React.createElement(Spinner_1.Spinner, { size: Spinner_1.SpinnerSize.small, hidden: !this.state.DownloadProcessing })),
            this.state.Items.length !== 0 ?
                (React.createElement("span", null,
                    React.createElement(DetailsList_1.DetailsList, { items: this.state.Items, columns: columns, setKey: "set", layoutMode: DetailsList_1.DetailsListLayoutMode.justified, compact: true, selectionMode: DetailsList_1.SelectionMode.multiple, checkboxVisibility: DetailsList_1.CheckboxVisibility.always, onShouldVirtualize: function () { return _this.state.ViewAll; }, selection: this._Selection }),
                    !this.state.ViewAll ?
                        (React.createElement("span", { className: "S2PagerRow" },
                            React.createElement(Pager, { total: this.state.MaxPages, current: this.state.CurrentPage, onSkipTo: this.handleSkip.bind(this) }),
                            React.createElement(Button_1.DefaultButton, { text: "View All", onClick: function () {
                                    _this.setState({ ViewAll: true, CurrentPage: 0 }, function () {
                                        _this._Selection.setAllSelected(false);
                                        _this.search(_this.props.Query);
                                    });
                                } })))
                        : (React.createElement("span", null)))) :
                (React.createElement("span", { className: "S2NoResults", hidden: this.state.Processing }, "No documents found")),
            this.props.GlobalSettings.manualRequestsEnabled ? (React.createElement("div", { className: "S2ManualRequest", hidden: this.state.Processing },
                React.createElement("span", null,
                    rxa[1],
                    React.createElement("a", { className: "S2ManualRequestLink", href: "#", onClick: function (evt) {
                            if (_this.props.OnManualRequest) {
                                _this.props.OnManualRequest();
                            }
                            evt.preventDefault();
                        } }, rxa[2])))) : React.createElement("span", null)));
    };
    // http://mottie.github.io/javascript-number-formatter/
    SearchResults.prototype.formatNumber = function (mask, value) {
        'use strict';
        if (!mask || isNaN(+value)) {
            return value; // return as it is.
        }
        var isNegative, result, decimal, group, posLeadZero, posTrailZero, posSeparator, part, szSep, integer, 
        // find prefix/suffix
        len = mask.length, start = mask.search(/[0-9\-\+#]/), prefix = start > 0 ? mask.substring(0, start) : '', 
        // reverse string: not an ideal method if there are surrogate pairs
        str = mask.split('').reverse().join(''), end = str.search(/[0-9\-\+#]/), offset = len - end, indx = offset + ((mask.substring(offset, offset + 1) === '.') ? 1 : 0), suffix = end > 0 ? mask.substring(indx, len) : '';
        // mask with prefix & suffix removed
        mask = mask.substring(start, indx);
        // convert any string to number according to formation sign.
        value = mask.charAt(0) === '-' ? -value : +value;
        isNegative = value < 0 ? value = -value : 0; // process only abs(), and turn on flag.
        // search for separator for grp & decimal, anything not digit, not +/- sign, not #.
        result = mask.match(/[^\d\-\+#]/g);
        decimal = (result && result[result.length - 1]) || '.'; // treat the right most symbol as decimal
        group = (result && result[1] && result[0]) || ','; // treat the left most symbol as group separator
        // split the decimal for the format string if any.
        mask = mask.split(decimal);
        // Fix the decimal first, toFixed will auto fill trailing zero.
        value = value.toFixed(mask[1] && mask[1].length);
        value = +(value) + ''; // convert number to string to trim off *all* trailing decimal zero(es)
        // fill back any trailing zero according to format
        posTrailZero = mask[1] && mask[1].lastIndexOf('0'); // look for last zero in format
        part = value.split('.');
        // integer will get !part[1]
        if (!part[1] || (part[1] && part[1].length <= posTrailZero)) {
            value = (+value).toFixed(posTrailZero + 1);
        }
        szSep = mask[0].split(group); // look for separator
        mask[0] = szSep.join(''); // join back without separator for counting the pos of any leading 0.
        posLeadZero = mask[0] && mask[0].indexOf('0');
        if (posLeadZero > -1) {
            while (part[0].length < (mask[0].length - posLeadZero)) {
                part[0] = '0' + part[0];
            }
        }
        else if (+part[0] === 0) {
            part[0] = '';
        }
        value = value.split('.');
        value[0] = part[0];
        // process the first group separator from decimal (.) only, the rest ignore.
        // get the length of the last slice of split result.
        posSeparator = (szSep[1] && szSep[szSep.length - 1].length);
        if (posSeparator) {
            integer = value[0];
            str = '';
            offset = integer.length % posSeparator;
            len = integer.length;
            for (indx = 0; indx < len; indx++) {
                str += integer.charAt(indx); // ie6 only support charAt for sz.
                // -posSeparator so that won't trail separator on full length
                /*jshint -W018 */
                if (!((indx - offset + 1) % posSeparator) && indx < len - posSeparator) {
                    str += group;
                }
            }
            value[0] = str;
        }
        value[1] = (mask[1] && value[1]) ? decimal + value[1] : '';
        // remove negative sign if result is zero
        result = value.join('');
        if (result === '0' || result === '') {
            // remove negative sign if result is zero
            isNegative = false;
        }
        // put back any negation, combine integer and fraction, and add back prefix & suffix
        return prefix + ((isNegative ? '-' : '') + result) + suffix;
    };
    ;
    return SearchResults;
}(React.Component));
exports.default = SearchResults;
//# sourceMappingURL=SearchResults.js.map